import { backendVersion, globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    campaignRewardList: [],
    campaignRewardDetail: {
      campaign_province: [],
      campaign_condition: [],
      campaign_level: [],
    },
    campaignMarketingList: [],
  },
  mutations: {
    editCampaignMarketing(state, data) {
      let index = state.campaignMarketingList.findIndex(
        (val) => val.dm_id == data.dm_id
      );
      state.campaignMarketingList.splice(index, 1, data);
    },
    addCampaignMarketing(state, data) {
      state.campaignMarketingList.push(data);
    },
    deleteCampaignMarketing(state, item) {
      let index = state.campaignMarketingList.indexOf(item);
      state.campaignMarketingList.splice(index, 1);
    },
    setCampaignMarketingList(state, data) {
      state.campaignMarketingList = data;
    },
    setCampaignRewardList(state, data) {
      state.campaignRewardList = data.map(val => {
        return { ...val, status: val.campaign_active == 2 || val.campaign_active == 4 ? true : false }
      });
    },
    setCampaignRewardDetail(state, data) {
      state.campaignRewardDetail = data;
    },
    addCampaignReward(state, data) {
      data.status = data.campaign_active == 2 || data.campaign_active == 4 ? true : false;
      state.campaignRewardList.unshift(data);
    },
    deleteCampaignReward(state, ID) {
      let index = state.campaignRewardList.findIndex(
        (val) => val.campaign_id == ID
      );
      state.campaignRewardList.splice(index, 1);
    },
  },
  actions: {
    fetchTransactionCryptoById({ }, campaign_id) {
      let url = `/api/v1/crypto/campaigns/transactions/${campaign_id}`;
      return globalAxios
        .get(url)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => false);
    },
    updateCampaignCrypto({ }, payload) {
      let url = `/api/v1/crypto/campaigns`;
      return globalAxios
        .put(url, payload)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return false;
          return true;
        })
        .catch((error) => false);
    },
    createCampaignCrypto({ }, payload) {
      let url = "/api/v1/crypto/campaigns";
      return globalAxios
        .post(url, payload)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => false);
    },
    editCampaignCrypto({ }, payload) {
      let url = "/api/v1/crypto/campaigns";
      return globalAxios
        .put(url, payload)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => false);
    },
    fetchCampaignCrypto({ }) {
      let url = "/api/v1/crypto/campaigns";
      return globalAxios
        .get(url)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => false);
    },
    async deleteCampaignMarketing({ commit, dispatch, rootState }, item) {
      let url = `/delete/campaignMarketing/${item.dm_id}`;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("deleteCampaignMarketing", item);
        return true;
      }
    },
    async changStatusCampaignMarketing({ commit, dispatch, rootState }, item) {
      let url = `/edit/campaignMarketing/${item.dm_id}`;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        console.log("change status success");
        return true;
      }
    },
    async editCampaignMarketing({ commit, dispatch, rootState }, item) {
      let url = `/edit/campaignMarketing/${item.dm_id}`;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          commit("editCampaignMarketing", res.data);
          return res;
        } else {
          return false;
        }
      }
    },
    async getCampaignMarketing({ commit, dispatch, rootState }) {
      let url = `/list/campaignMarketing`;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        if (res.msg == true) {
          commit("setCampaignMarketingList", res.data);
          return res;
        } else {
          return [];
        }
      }
    },
    async addCampaignMarketing({ commit, dispatch, rootState }, form) {
      let url = `/create/campaignMarketing`;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return "error";
      } else {
        commit("addCampaignMarketing", res.data);
        return res;
      }
    },
    async changeStatusCampaignReward({ dispatch }, ID) {
      let url =
        backendVersion.version + "/backoffice/campaign/editStatus/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        alert("Can't change this campaign status.");
        return false;
      } else {
        if (res.msg == true) {
          return true;
        } else {
          alert("Can't change this campaign status.");
          return false;
        }
      }
    },
    async deleteCampaignReward({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/backoffice/campaign/delete/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        alert("Can't delete this campaign.");
        return false;
      } else {
        if (res.msg == true) {
          commit("deleteCampaignReward", ID);
          return true;
        } else {
          alert("Can't delete this campaign.");
          return false;
        }
      }
    },
    async createCampaignReward({ dispatch, commit }, form) {
      let url = backendVersion.version + "/backoffice/campaign/create";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        console.log(res);
        if (res.msg == true) {
          commit("addCampaignReward", res.data);
          return true;
        } else {
          return false;
        }
      }
    },
    async getCampaignRewardList({ dispatch, commit }) {
      let url = backendVersion.version + "/backoffice/campaign/list";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setCampaignRewardList", res.data);
        return res;
      }
    },
    async getCampaignRewardDetail({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/backoffice/campaign/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setCampaignRewardDetail", res.data);
        return res;
      }
    },
  },
  getters: {},
};
